// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab9282d0","635":"504cc5cb"}[chunkId] + ".chunk.js";
};